import requestv2 from "~/utils/http-v2";

const formPaymentApi = {
	gets : async (params) => {
		const url = 'v2/form/payment';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/form/payment';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/form/payment/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/form/payment/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/form/payment/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	count : async (params) => {
		const url = 'v2/form/payment/count';
		return await requestv2.get(url, {params});
	},
};

export default formPaymentApi;